import { render, staticRenderFns } from "./PolicySelectList.vue?vue&type=template&id=5f88e5c6&scoped=true&"
import script from "./PolicySelectList.vue?vue&type=script&lang=js&"
export * from "./PolicySelectList.vue?vue&type=script&lang=js&"
import style0 from "./PolicySelectList.vue?vue&type=style&index=0&id=5f88e5c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f88e5c6",
  null
  
)

export default component.exports